export {default} from './Main';



// WEBPACK FOOTER //
// ./src/components/AuthLayout/Main/index.ts